import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=2f837cbd&scoped=true&"
import script from "./UserMenu.vue?vue&type=script&lang=js&"
export * from "./UserMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserMenu.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserMenu.vue?vue&type=style&index=1&id=2f837cbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f837cbd",
  null
  
)

export default component.exports